import { CapoPlugin } from "/builds/david.s/LocalinoHubItemSpotter/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];